import { ROUTES_APPLICATION_PATH } from "../../../../routes.constants";
import { buildMenu, SECTION_LABELS } from './utils';

export const SUPERMARKET_ITEMS = {
  mercadosConveniencias: () => ({
    pageName: "Mercados & Conveniências",
    route: ROUTES_APPLICATION_PATH.SORTIMENTO.COMPONENT_URL[0],
    icon: "shoppingBag",
  }),
};

export const getSupermarketNavigationOptions = (t, tenantContext, config = {}, options = {}) => {
  const {
    transactionalItems = [
      SUPERMARKET_ITEMS.mercadosConveniencias(),
    ],
    dataItems = [],
    opportunityItems = [],
  } = config;

  const sortimento = buildMenu({
    menuName: "Sortimento",
    route: ROUTES_APPLICATION_PATH.SORTIMENTO.BASE_URL,
    icon: "sortimento",
    sectionDefs: [
      {
        label: SECTION_LABELS.OPPORTUNITIES,
        items: opportunityItems,
      },
      {
        label: SECTION_LABELS.TRANSACTIONAL,
        items: transactionalItems,
      },
      { 
        label: SECTION_LABELS.DATA, 
        items: dataItems 
      },
    ],
    options
  });

  return [sortimento].filter(Boolean);
};